import React, { useState, useEffect, useRef  } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { config } from '../config';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { Messages } from 'primereact/messages';
import { Card } from 'primereact/card';
import Container from 'react-bootstrap/Container';
import {InputSwitch} from 'primereact/inputswitch';
import { useAuth } from '../contexts/AuthContext';
import { Toolbar } from 'primereact/toolbar';
import { Dropdown } from 'primereact/dropdown';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import AccessState from './AccessState';
import usePageAccessRedirect from '../hooks/usePageAccessRedirect';

import '../config.js'

const BarcodeReaders = () => {
  // Load the status page script
  useStatusPageScript();
  
    const { apid } = useParams();
    const [comPorts, setComPorts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const msgs = useRef(null);
    const toastBC = useRef(null);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [selectedComPort, setSelectedComPort] = useState(null);
    const [displayDialog, setDisplayDialog] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [createVisible, setCreateVisible] = useState(false);
    const [newComPort, setNewComPort] = useState(''); 
    const [newType, setNewType] = useState(0);
    const { accessIssue, clearAccessIssue, handleAccessError } = usePageAccessRedirect({
      deniedTitle: 'Barcode Readers Access Denied',
      deniedMessage: 'You do not have permission to view or manage barcode readers for this access point.',
    });
    

const toast = useRef(null);


useEffect(() => {
    const fetchComPorts = async () => {
        await getComPorts();
      };
  
      fetchComPorts();
}, [apid]);

const getComPorts = async () => {
  clearAccessIssue();
    setLoading(true);
    const token = localStorage.getItem('token');
    let header = {
        headers: {
        Authorization: `Bearer ${token}`,
        },
    }

    axios.get(`${global.config.url}/accesspoints/barcodereader/${apid}`, header)
        .then(response => {
            setComPorts(response.data);
            setLoading(false);
        })
        .catch(async error => {
          if (handleAccessError(error)) {
            setLoading(false);
                return;
            }
            setError(error.message);
            setLoading(false);
            setComPorts([]);
        })
}


const endContent = (
    <React.Fragment>
        <span className="p-input-icon-left mr-3 mt-1">
            {/* <i className="pi pi-search" /> */}
            {/* <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." /> */}
            <Button icon="pi pi-refresh" className="p-button-text" onClick={() => getComPorts()} disabled={loading} tooltip="Refresh barcode readers" tooltipOptions={{position: "bottom"}}/>
            <Button icon="pi pi-trash" className="p-button-danger mx-3" rounded loading={deleteLoading} disabled={loading} onClick={() => confirm(null)} tooltip="Delete selected barcode reader port" tooltipOptions={{position: "bottom"}} />
            <Button icon="pi pi-plus" className="p-button-success p-mr-2" rounded loading={loading} disabled={loading} onClick={() => setCreateVisible(true)} tooltip='Add a new barcode reader port'/>
        </span>
    </React.Fragment>
);

const textEditor = (options) => {
    console.log(options);
    return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
};

const numberEditor = (options) => {
    console.log(options);
    return <InputText type="number" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
};

const onRowEditComplete = (rowData) => {
    confirm(false, rowData);
}

const footerContent = (
  <div>
      <Button label="No" icon="pi pi-times" onClick={() => setCreateVisible(false)} className="p-button-text" />
      <Button label="Yes" icon="pi pi-check" onClick={() => confirm(true)} autoFocus />
  </div>
);

const addComPort = async () => {
    try{
      clear(true);
      msgs.current.show({severity: 'info', summary: '', detail: `Adding Barcode Reader...`});
      setLoading(true);
      const token = localStorage.getItem('token');
      var axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      };
      let newReader = {
        comPort: newComPort,
        type: parseInt(newType),
        accessPointId: parseInt(apid)
      }
      const response = await axios.post(global.config.url + `/accesspoints/addbarcodereader`, newReader, axiosConfig);
      console.log(response);
      msgs.current.clear();
      if(response.status === 201){
        msgs.current.show({severity: 'success', summary: '', detail: `Barcode Reader successfully added.`});
        getComPorts();
        setCreateVisible(false);
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error adding the Barcode Reader.'});
      }
    } catch (error) {
      console.error('Error adding Barcode Reader:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to create barcode readers for this access point.' })) {
        return;
      }
      else{
        msgs.current.clear();
        msgs.current.show({severity: 'error', summary: '', detail: 'Error adding the Barcode Reader.'});
      }
    }
    setLoading(false);
  };

  const deleteComPort = async () => {
    try{
      clear(true);
      console.log(selectedComPort);
      msgs.current.show({severity: 'info', summary: '', detail: `Deleting Barcode Reader...`});
      setLoading(true);
      const token = localStorage.getItem('token');
      var axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      };
      const response = await axios.delete(global.config.url + `/accesspoints/deletebarcodereader/` + selectedComPort.id, axiosConfig);
      console.log(response);
      msgs.current.clear();
      if(response.status === 204){
        msgs.current.show({severity: 'success', summary: '', detail: `Barcode Reader successfully deleted.`});
        getComPorts();
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error deleting the barcode reader.'});
      }
    } catch (error) {
      console.error('Error deleting the barcode reader Port:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to delete this barcode reader.' })) {
        return;
      }
      else{
        msgs.current.clear();
        msgs.current.show({severity: 'error', summary: '', detail: 'Error deleting the barcode reader.'});
      }
    }
  };


const confirm = (create, newData) => {
      toastBC.current.show({
        severity: 'info',
        sticky: true,
        className: 'border-none',
        content: (
            <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                <div className="text-center">
                    <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                    <div className="font-bold text-xl my-3">Are you sure?</div>
                </div>
                <div className="flex align-items-center">
                    {create === false && <Button onClick={(e) => updateComPort(newData)} type="button" label="Yes" className="p-button-success w-6rem" />}
                    {create === true && <Button onClick={(e) => addComPort()} type="button" label="Yes" className="p-button-success w-6rem" />}
                    {create === null && <Button onClick={(e) => deleteComPort()} type="button" label="Yes" className="p-button-danger w-6rem" />}
                    <Button onClick={(e) => clear(false)} type="button" label="No" className="p-button-warning w-6rem mx-4" />
                </div>
            </div>
        )
      });
  
  };
  
  const clear = () => {
    toastBC.current.clear();
  };
  
  const updateComPort = async (newData) => {
    try{
      clear(true);
      const token = localStorage.getItem('token');
      var axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      };
      const response = await axios.put(global.config.url + `/accesspoints/editbarcodereader`, newData.newData, axiosConfig);
      console.log(response);
      if(response.status === 204){
        msgs.current.show({severity: 'success', summary: '', detail: `Barcode Reader for tile ${newData.newData.accessPoint.tile} successfully updated.`});
        getComPorts();
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error updating the barcode reader.'});
      }
    } catch (error) {
      console.error('Error updating the barcode reader Port:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to update this barcode reader.' })) {
        return;
      }
    }
  };

if (accessIssue) {
    return <AccessState {...accessIssue} />;
}
  


return (
    <Card className ="justify-content-md-center mx-5">
        <Container >
        <div className="card">
            <Toolbar 
                start={
                <Container className="flex align-content-center flex-wrap">
                    <Button link icon="pi pi-arrow-left" onClick={() => navigate(-1)} className='flex'/> 
                    <h4 className='flex mt-2'>Barcode Reader Ports</h4> 
                </Container>}
                end={endContent}/>
            </div>
            <Messages ref={msgs} />
            <Toast ref={toastBC} position="top-center" />
            <div className='justify-content-md-center mt-3'>
                <DataTable 
                    // ref={dt} 
                    value={comPorts}
                    // globalFilter={globalFilter}
                    dataKey="id"
                    selectionMode='single' selection={selectedComPort} onSelectionChange={(e) => setSelectedComPort(e.value)}
                    editMode='row' onRowEditComplete={onRowEditComplete}> 
                    <Column field="comPort" header="Barcode Reader COM Port" sortable editor={(options) => textEditor(options)}/>
                    <Column field="accessPoint.tile" header="Tile ID" sortable/>
                    <Column field="accessPoint.gate" header="Gate Name"></Column>
                    <Column field="accessPoint.client.name" header="Client Name"></Column>
                    <Column field="accessPoint.location.name" header="Location Name"></Column>
                    <Column field="type" header="Barcode Reader Type" sortable editor={(options) => numberEditor(options)}></Column>
                    <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                </DataTable>
            </div>
            <br></br>
            <p className="text-center">Barcode Reader type 0: Normal Nortech</p>
            <p className="text-center">Barcode Reader type 1: Check-in</p>
            <p className="text-center">Barcode Reader type 2: Legend Member number type</p>
        </Container>
          <Dialog header="Create Barcode Reader" className='justify-content-center' visible={createVisible} onHide={() => setCreateVisible(false)} 
            style={{ width: 'auto' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} footer={footerContent}>

            <Toast ref={toast} />
            <Container className="flex align-content-center flex-wrap">
              <span className="flex p-float-label my-4">
                <InputText
                    id="barcodereadercomport"
                    name="barcodereadercomport"
                    value={newComPort}
                    onChange={(e) => setNewComPort(e.target.value)}
                />
                <label htmlFor="barcodereadercomport">COM Port</label>
              </span>
              <span className="flex p-float-label my-4 ml-3">
                <InputText
                    id="type"
                    name="type"
                    value={newType}
                    onChange={(e) => setNewType(e.target.value)}
                />
                <label htmlFor="type">Type</label>
              </span>
            </Container>
          </Dialog>
    </Card>
);

}
export default BarcodeReaders;